<template>
  <div
    v-if="isLoading"
    class="PageLoadingState"
  >
    <span class="is-loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      isLoading: (state) => state.ui.loadingState,
    }),
  },
};
</script>
